import { Feature } from 'src/.generated/Feature.EnterpriseWeb.model';
import { BaseSubmitAction, BaseSubmitProps, ExecutionResult } from '../../BaseSubmitAction';
import { replacePlaceholders } from 'lib/forms/FormFieldUtils';
import { Field } from '@sitecore-jss/sitecore-jss-nextjs';
import { Affiliate, AffiliateDispatchAction } from 'lib/context/AffiliateContext';

type UpdateAffiliateFields =
  Feature.EnterpriseWeb.RenewalByAndersen.Forms.SubmitActions.UpdateAffiliate['fields'];

export class UpdateAffiliate extends BaseSubmitAction {
  constructor(params: BaseSubmitProps) {
    super(params);
  }

  private getSubstitutedValue(fieldName: keyof UpdateAffiliateFields): string {
    const actionFieldsProps = this.actionFieldsProps as UpdateAffiliateFields;

    if (actionFieldsProps) {
      return replacePlaceholders(
        (actionFieldsProps[fieldName] as Field<string>)?.value,
        this.formData,
        true
      );
    }
    return '';
  }

  override async executeAction(): Promise<ExecutionResult> {
    const affiliateZip = this.getSubstitutedValue('affiliateZip' as keyof UpdateAffiliateFields);

    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        zipcode: affiliateZip,
        language: 'en',
      }),
    };

    return fetch(`/api/rba/affiliate/get-affiliate-data-by-zipcode`, requestOptions)
      .then(async (response) => {
        const { affiliateData } = await response.json();
        const dispatchAction: AffiliateDispatchAction = {
          result: {
            affiliateResponse: affiliateData as Affiliate,
          },
          type: 'updateAffiliate',
        };

        return new Promise<ExecutionResult>((resolve) => {
          resolve({
            result: dispatchAction,
            success: affiliateData !== null ? true : false,
            errorMessage: this.actionFieldsProps?.errorMessage?.value,
          });
        });
      })
      .catch((error) => {
        console.error(`${error.message}`);
        return new Promise<ExecutionResult>((resolve) => {
          resolve({
            success: false,
            errorMessage: this.actionFieldsProps?.errorMessage?.value,
          });
        });
      });
  }
}
